import React, { useContext } from 'react'
import { VideoContext } from '../../../Context'
import { FeedItem } from '../../../Api'
import { colors } from '../../consts'
import { getPartnerLabel, logEvent } from '../../../Utils'
import { VideoTitle, VideoCardCon, VideoThumb, BlurredBackground } from './styles'
import { Play } from '../../Icons'
import { convertHourMinSec } from '../../../Utils/formatting'
import { PartnerLabel, TitleCon } from '../Articles/styles'
import { Img } from '../../Image/Img'

type VideoCardProps = {
  video: FeedItem
  theme?: 'light' | 'dark'
  section?: string
  size?: 'home_featured' | 'featured' | 'normal' | 'small'
}

export const VideoCard: React.FC<React.PropsWithChildren<VideoCardProps>> = ({
  video,
  section,
  theme = 'light',
  size,
}) => {
  const { loadAndShowVideo } = useContext(VideoContext)!
  const log = (event: string) => {
    if (section)
      logEvent(event, {
        section: section,
        title: video.title,
        tags: video.tags,
      })
  }

  const handleVideoClick = () => {
    loadAndShowVideo(video)
  }

  const getVideoDuration = () => {
    if (!video?.duration) return ''

    return convertHourMinSec(video.duration)
  }

  return (
    <VideoCardCon
      size={size}
      uiTheme={theme}
      onClick={() => {
        log('video_click')
        handleVideoClick()
      }}
    >
      {video.previewImage ? (
        <>
          <VideoThumb size={size} backgroundImg={video.previewImage}>
            <BlurredBackground backgroundImg={video.previewImage} />
            <div className="imgCon">
              <Img src={video.previewImage} alt={video.title || ''} />
            </div>
            <Play className="playBtn" width={50} height={50} fill={colors.white} />
            <div className="durationCon">
              <div className="durationText">{getVideoDuration()}</div>
            </div>
          </VideoThumb>
        </>
      ) : (
        <div className="placeholder" />
      )}
      <TitleCon uiTheme={theme}>
        <PartnerLabel uiTheme={theme}>
          <p>{getPartnerLabel(video)}</p>
        </PartnerLabel>
        <VideoTitle uiTheme={theme}>{video.title || ''}</VideoTitle>
      </TitleCon>
    </VideoCardCon>
  )
}
